import { OwnershipModel } from '@app/common/models/ownership.model';
import { CaseSubjectModel } from '@app/ps/models/case-subject.model';
import { CaseOwnershipValidation } from '@app/ps/cases/components/field-validation-msg/field-validation-msg.component';

export class CaseOwnershipModel {
  id: number;
  ownership: OwnershipModel;
  parentCaseOwnership: CaseOwnershipModel;
  isParent: boolean;
  singlePayment?: boolean;
  price?: number;
  landPrice?: number;
  easementPrice?: number;
  compensationPrice?: number;
  podil?: string;
  paymentType?: string;
  accountNumber?: string;
  bankCode?: string;
  variableSymbol?: string;
  easementFutureContractNumber?: string;
  easementFutureContractStatus?: string;

  // helpers
  caseSubjects?: CaseSubjectModel[];
  requirements?: CaseOwnershipValidation[];
  errors?: CaseOwnershipValidation[];
  opened?: boolean;

  // helpers for grouped caseOwnership
  sumPrice?: number;
  ownershipIds: number[];
}
